export default __webpack_public_path__ + "static/media/icon.317c089b.png";